import React, {Component} from 'react';
import toastr from "toastr";
import axios from "axios";
import {Route, Switch, Redirect, NavLink, Link} from 'react-router-dom';

import http from "../../services/httpService";
//import config from "../../config.json";
import {setCurrentUserName, getCurrentUserId, getJwt} from "../../services/authService";
import ReactGA from "react-ga";
import URLShortenerPerformance from "./URLShortenerPerformance";
import PersonalInfo from "./myProfile/PersonalInfo";
import Security from "./myProfile/Security";
import DateTime from "./myProfile/DateTime";

class Settings extends Component {
    constructor(props) {
        super(props);

        this.state =
            {
                isEditing: false,
                message: props.message,
                saving: false,
                notifications: [],
                selectedOption: '',
                selectedRadioOption: 'all',
                title: '',
                link: '',
                count_push_subscrib: 0,
                count_fb_subscrib: 0,
                count_type_subscrib: "all",
                navigation: 1,
                selectedFile: null,
                selectedFileData: null,
                loaded: 0,
                profile_photo: props.profile_photo !== null ? props.profile_photo : "/img/default-user.jpg",
                spinnerActive: false,
                user: this.props.user
            };

    }


    toggleNavigation = async (e) => {
        await this.setState({
            navigation: e
        })
        this.props.history.push(e === 1 ? '/edit-profile/personal-info' : e === 2 ? '/edit-profile/security' : '/edit-profile/date-time')
    };

    async componentDidMount() {
        // ReactGA.pageview(window.location.pathname + window.location.search);

        if (this.props.location.pathname === '/edit-profile/security') {
            this.setState({navigation: 2})
        } else if (this.props.location.pathname === '/edit-profile/date-time') {
            this.setState({navigation: 3})
        } else if (this.props.location.pathname === '/edit-profile') {
            this.props.history.push('/edit-profile/personal-info')
        }

        try {
            // const user_id = await getCurrentUserId();
            // const result = await http.get('api/user/' + user_id, { headers: { authorization: getJwt() } });
            const result = await http.get('api/user_info', {headers: {authorization: getJwt()}});
            const data = result.data.data;
            this.setState({message: data});

            if (!data) {
                toastr.error("User id does not match. :(  Please log in again.");
                this.props.history.push('/logout');
            } else {
                setCurrentUserName(data.name);
            }
        } catch (ex) {
            if (ex.response && ex.response.status === 404)
                toastr.error("Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                toastr.error(ex.response.data.message);
                this.props.history.push('/logout');
            }
        }

        // this.props.history.push(this.state.navigation === 1 ? '/edit-profile/personal-info' : this.state.navigation === 2 ? '/edit-profile/security' : '/edit-profile/date-time')

    }

    changeMessageData = (first_name, last_name, name) => {
        // console.log('first_name: ', first_name)
        // console.log('last_name: ', last_name)
        // console.log('name: ', name)
        let message = this.state.message
        message.first_name = first_name
        message.last_name = last_name
        message.name = name
        this.setState({
            message
        })
    }

    componentDidUpdate=()=> {
        if (this.state.email !== this.props.email) {
            this.setState({
                    message: Object.assign(
                        {},
                        this.state.message,
                        {
                            email: this.props.email
                        })
                }
            );
        }
        if (this.state.profile_photo !== this.props.profile_photo) {
            this.setState({
                profile_photo: this.props.profile_photo
            });
        }
        // console.log('Cao navigacijo: ', this.props.location)
        // if((this.props.location.pathname === '/edit-profile/security')&&(this.state.navigation !== 2)){
        //     this.setState({navigation: 2})
        // }else if((this.props.location.pathname === '/edit-profile/date-time')&&(this.state.navigation !== 3)){
        //     this.setState({navigation: 3})
        // }
    }

    render() {

        let myData = this.state.message || {};

        return (
            <React.Fragment>
                <h1 className='main-title'>My Profile</h1>
                <div className='tabs-navigation'>
                    <div
                        onClick={e => this.toggleNavigation(1)}
                        className={this.state.navigation === 1 ? "navigation-tab active" : 'navigation-tab'}
                        id='shorten-url'>
                        Personal Info
                    </div>
                    <div
                        onClick={e => this.toggleNavigation(2)}
                        className={this.state.navigation === 2 ? "navigation-tab active" : 'navigation-tab'}>
                        Security
                    </div>

                    <div
                        onClick={e => this.toggleNavigation(3)}
                        className={this.state.navigation === 3 ? "navigation-tab active" : 'navigation-tab'}>
                        Date & Time
                    </div>

                </div>

                <div>
                    <Switch>
                        <Route path="/edit-profile/personal-info"
                               render={(props) =>
                                   <PersonalInfo
                                       message={this.state.message}
                                       parentMethod={this.toggleEdit}
                                       openModal={this.props.openModal}
                                       acceptModal={this.props.acceptModal}
                                       user={this.state.user}
                                       profilePhoto={this.state.profile_photo}
                                       changeMessageData = {this.changeMessageData}
                                       updateUserFromServer={this.props.updateUserFromServer}
                                       {...this.props}
                                   />
                               }
                        />

                        <Route path="/edit-profile/security"
                               render={(props) => <Security
                                   toggleNavigation={this.toggleNavigation}
                                   user={this.state.user}
                                   {...this.props}
                                   {...this.props}
                               />}
                        />
                        <Route path="/edit-profile/date-time"
                               render={(props) => <DateTime
                                   {...this.props}
                                   updateUserFromServer={this.props.updateUserFromServer}
                               />}
                        />

                    </Switch>
                </div>
            </React.Fragment>
        )
    }
}

export default Settings;